import React, { Component } from 'react';
import { connect } from 'react-redux'
import ConfiguracionSesionVista from './ConfiguracionSesionVista';

////Importación de actions.
import {
    searchConfigurationSession,
    resetStateConfigSesionVista
} from '../actions/ConfiguracionSesionVista';

const mapStateToProps = (state) => {
    return {
        data: state.configuracionSesionVista,
        concierge: state.concierge
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        searchConfigurationSession: (currentScope) => {
            dispatch(searchConfigurationSession(currentScope));
        },
        resetStateConfigSesionVista: () => {
            dispatch(resetStateConfigSesionVista());
        }
    }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(ConfiguracionSesionVista);

export default Container;